export const projectType = {
  MULESOFT_INTEGRATION: "MULESOFT_INTEGRATION",
  MULTI_CLOUD: "MULTI_CLOUD",
  MULESOFT_RPA_IDP: "MULESOFT_RPA_IDP",
  MULESOFT_EDI: "MULESOFT_EDI",
  HYPER_AUTOMATION: "HYPER_AUTOMATION",
  INFORMATICA_INTEGRATION: "INFORMATICA_INTEGRATION",
  OTHERS: "OTHERS",
};
